import { useNavigate, useOutletContext } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import {
  FinancialProjectForSelectFragment,
  ProjectSaleInvoiceFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import useSearchParams from 'modules/core/hooks/useSearchParams'

import SaleInvoicesUpsertSidePanel from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel'

const SaleInvoiceUpsertPanel = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { invoiceId } = useParams()
  const { employee } = useCurrentSession()
  const { createCreditNote } = useSearchParams<{
    createCreditNote?: boolean
  }>()

  const { project } = useOutletContext<{
    project: ProjectSaleInvoiceFragment
  }>()

  const defaultLegalEntity = project?.legalEntity || employee?.legalEntity
  const defaultCurrency = defaultLegalEntity?.currency
  const financialProject: FinancialProjectForSelectFragment = {
    id: project.id,
    code: project.code,
    name: project.name,
    subprojectsConnection: project.subprojectsConnection,
  }

  const isSaleInvoiceDetail = location.pathname.includes('/sale_invoices/detail/')

  const onClose = () => {
    if (isSaleInvoiceDetail) {
      navigate(
        navigation.projects.id.details.sale_invoices.detail.fullPath({
          id: project.id,
          invoiceId: invoiceId || '',
        })
      )
    } else {
      navigate(navigation.projects.id.details.sale_invoices.fullPath({ id: project.id }))
    }
  }

  return (
    <SaleInvoicesUpsertSidePanel
      invoiceId={invoiceId}
      onClose={onClose}
      defaultCurrency={defaultCurrency}
      defaultLegalEntity={defaultLegalEntity}
      contact={project.client}
      financialProject={financialProject}
      originPageInvoices={false}
      createCreditNoteProp={createCreditNote}
    />
  )
}

export default SaleInvoiceUpsertPanel
